import clsx from 'clsx';
import { createSearchParams, useNavigate } from 'react-router-dom';

import { routes } from 'router';
import { appService } from 'services';

const { string, node } = require('prop-types');

const ZendeskLink = ({ children, to = '', className = '' }) => {
  const navigate = useNavigate();

  const goToSso = () => {
    const params = {
      return_to: appService.getAssistanceUrl()
    };

    if (to) {
      params.return_to = `${params.return_to}${to}`;
    }

    navigate({
      pathname: routes.sso.path,
      search: createSearchParams(params).toString()
    });
  };

  return (
    <button type="button" className={clsx(className)} onClick={goToSso}>
      {children}
    </button>
  );
};

ZendeskLink.propTypes = {
  children: node.isRequired,
  to: string,
  className: string
};

export default ZendeskLink;
